import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, { useEffect, useState } from "react";

const headers = [
  {
    key: "warehouse_name",
    name: "Warehouse Name",
  },
  {
    key: "phone1",
    name: "Phone",
  },
  {
    key: "address",
    name: "Address",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "warehouse_code",
    name: "Warehouse ID",
  },
  {
    key: "warehouse_name",
    name: "Warehouse Name",
  },
  {
    key: "phone1",
    name: "Phone 1",
  },
  {
    key: "phone2",
    name: "Phone 2",
  },
  {
    key: "phone3",
    name: "Phone 3",
  },
  {
    key: "phone4",
    name: "Phone 4",
  },
  {
    key: "address",
    name: "Address",
  },
];

const WarehouseList = () => {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/warehouse",
    defaultQuery: "status=ACTIVE",
    included: false,
  });

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      setSearchValue(trimmed); // Store search term
      setQuery({
        search: value.trim(),
      });
    } else {
      setSearchValue(""); // Clear search term
      setQuery({});
    }
  };

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Warehouse List"
      data={data}
      headers={headers}
      detailPopupHeaders={detailPopupHeaders}
      detailPopupTitle="Warehouse Information"
      idKey="warehouse_id"
      endPoint="/warehouse"
      module="Warehouse"
      subModule="Warehouse List"
      setCurrentPage={setCurrentPage}
      hasDetails
      hasSearch
      hasCreate
      hasActions
      createPath={`/warehouse/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
};

export default WarehouseList;
